export enum Selection {
    All = 0,
    Include = 1,
    Exclude = 2,
}